import React, { useState } from "react";
import Modal from "react-modal";
import { useTranslation } from "react-i18next";
import LoginForm from "./LoginForm";

interface LoginFormModalProperties {
    readonly onAfterClose: () => void;
    readonly forceOpenModal?: boolean;
}

export default function LoginFormModal({ onAfterClose, forceOpenModal }: LoginFormModalProperties): React.JSX.Element {
    const { t } = useTranslation("header");

    const [internalOpen, setInternalOpen] = useState<boolean>(true);

    const modalIsOpen = forceOpenModal ?? internalOpen;

    const closeModal = (): void => {
        setInternalOpen(false);
    };

    return (
        <Modal
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            className="modal-dialog modal-transition"
            overlayClassName="react-modal-backdrop modal-transition"
            closeTimeoutMS={150}
            onAfterClose={onAfterClose}
        >
            <div className="modal-content">
                <div className="modal-header empty">
                    <button type="button" className="close" onClick={closeModal}>
                        <i className="fa-solid fa-times"></i>
                    </button>
                </div>

                <div className="modal-body">
                    <div className="row">
                        <div className="well well-transparent">
                            <p className="fakeh3">{t("login")}</p>
                            <p className="fakeh4">{t("alreadyShoppedHere")}</p>

                            <LoginForm />

                            <a href="/registrace" className="btn btn-link btn-nowrap pull-left">{t("newRegistration")}</a>
                            <a href="/zapomenute-heslo" className="btn btn-link btn-nowrap pull-right">{t("forgotPassword")}</a>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
}
